export const rootRoutes = {
  task: '/task/:taskId',
  taskComment: '/task/:taskId/comment/:id',
  taskList: '/task-list',
  allTaskList: `/task-list/:filterId?`,
  groupedTaskList: `/task-list/group/:groupId`,
  filteredTaskList: `/task-list/group/:groupId/:groupKey/:filterId?`,
  search: '/search',
  login: '/login',
};
